import { render, staticRenderFns } from "./AnalyseSummaryResult.vue?vue&type=template&id=5237cf2f&scoped=true"
import script from "./AnalyseSummaryResult.vue?vue&type=script&lang=js"
export * from "./AnalyseSummaryResult.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5237cf2f",
  null
  
)

export default component.exports